export const MAX_PLANNERS = 2;
export const SHARE_CODE_LENGTH = 8;
export const PAYMENT_AMOUNT = 30;
